import { FokParameterChoice, Markup } from '@fora-monorepo/employer-my-pages-common/types';
import { getPreviousAndFutureMarkupsOld, isPensionParameter } from '@fora-monorepo/employer-my-pages-common/utils';
import { isFuture } from '@fora-monorepo/date-utils';
import { DateRangeItemDetails, Flex, ResponsiveSpacing } from '@foradevelopment/fora-ui';

import { getParameterTKeys } from '../../common/utils';
import { useTypedTranslation } from '../../i18n/i18n';

// TODO: REMOVE FILE MANAGE EMPLOYMENTS

export const MarkupAndParametersListOld = ({
  markups,
  activeMarkup,
  marginTop,
}: {
  markups: Markup[];
  activeMarkup: Markup | null;
  marginTop?: ResponsiveSpacing;
}) => {
  const { t } = useTypedTranslation();
  const { previousMarkups, futureMarkups } = getPreviousAndFutureMarkupsOld(markups);

  const isActiveMarkupFuture = activeMarkup && isFuture(activeMarkup.startDate);

  return (
    <Flex flexDirection="column" rowGap={40} marginTop={marginTop}>
      {activeMarkup && !isActiveMarkupFuture && (
        <DateRangeItemDetails
          title={t('list.markupAndParametersList.activeTitle')}
          subTitle={activeMarkup.fokText || `${activeMarkup.fokId} (fokText saknas)`}
          startDate={activeMarkup.startDate}
          endDate={activeMarkup.endDate}
        />
      )}
      {futureMarkups.map((markup, index) => (
        <DateRangeItemDetails
          title={t('list.markupAndParametersList.futureTitle')}
          subTitle={markup.fokText || `${markup.fokId} (fokText saknas)`}
          startDate={markup.startDate}
          endDate={markup.endDate}
          key={index}
        />
      ))}
      {previousMarkups.map((markup, index) => (
        <DateRangeItemDetails
          title={t('list.markupAndParametersList.previousTitle')}
          subTitle={markup.fokText || `${markup.fokId} (fokText saknas)`}
          startDate={markup.startDate}
          endDate={markup.endDate}
          key={index}
        />
      ))}
      {activeMarkup?.fokParameterChoices?.map((fokParameterChoice: FokParameterChoice, index) => {
        const { name, description } = getParameterTKeys(fokParameterChoice.parameterValue);
        return (
          <DateRangeItemDetails
            title={t('list.markupAndParametersList.parameterTitle')}
            subTitle={t(name)}
            description={isPensionParameter(fokParameterChoice.parameterValue) ? t(description) : undefined}
            startDate={isPensionParameter(fokParameterChoice.parameterValue) ? undefined : fokParameterChoice.startDate}
            endDate={fokParameterChoice.endDate}
            key={index}
          />
        );
      })}
    </Flex>
  );
};
